import React from "react";
import PropTypes from "prop-types";
import cl from "classnames";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import classes from "./styles.module.scss";

const transitionNames = {
  enter: classes["ArrowPopup--transition--enter"] || "--enter",
  enterActive:
    classes["ArrowPopup--transition--enter-active"] || "--enter-active",
  leave: classes["ArrowPopup--transition--leave"] || "--leave",
  leaveActive:
    classes["ArrowPopup--transition--leave-active"] || "--leave-active",
};

const ArrowPopup = ({ children, className, show, below, ...otherProps }) => (
  <TransitionGroup>
    {show && (
      <CSSTransition
        classNames={transitionNames}
        timeout={200}
        key="arrowPopup"
      >
        <div
          className={cl(classes.ArrowPopup, className, {
            [classes.below]: below,
          })}
          {...otherProps}
        >
          {children}
        </div>
      </CSSTransition>
    )}
  </TransitionGroup>
);

ArrowPopup.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  show: PropTypes.bool.isRequired,
  below: PropTypes.bool,
};

ArrowPopup.defaultProps = {
  below: false,
};

export default ArrowPopup;
